import { render, staticRenderFns } from "./ProjectMessagesPanel.vue?vue&type=template&id=6b4c6f62&scoped=true"
import script from "./ProjectMessagesPanel.vue?vue&type=script&lang=js"
export * from "./ProjectMessagesPanel.vue?vue&type=script&lang=js"
import style0 from "./ProjectMessagesPanel.vue?vue&type=style&index=0&id=6b4c6f62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4c6f62",
  null
  
)

export default component.exports